import { render, staticRenderFns } from "./gc-toolbar-button-email.vue?vue&type=template&id=01104804"
import script from "./gc-toolbar-button-email.vue?vue&type=script&lang=js"
export * from "./gc-toolbar-button-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports